import useSWR from "swr";
import ApiService, { defaultSWROption } from "@/services/api/api.service";

const CONFIG_ENDPOINT = "/configs/";

export interface Config {
  language?: string; // 'en' または 'ja'
  displayGroupLabel?: string;
  enableBi?: boolean; // BI(Superset)の有効化
  isYearlyView?: boolean; // BI分析画面の年次/月次表示切り替え
  showOverviewByDefault?: boolean; // トップページの全体概要をデフォルト表示するか
  appType?: "voc" | "voe"; // アプリケーションタイプ（VoC / VoE）
  env?: string; // 環境名（例: kumiai, develop, staging）
  enableAgent?: boolean; // エージェント機能の有効化
}

const defaultConfig: Config = {
  language: "ja",
  displayGroupLabel: "部署",
  enableBi: false,
  isYearlyView: false,
  showOverviewByDefault: true,
  appType: "voc",
  env: "",
  enableAgent: false,
};

function useConfig() {
  const fetcher = () =>
    ApiService.fetchData<undefined, Config>({
      url: CONFIG_ENDPOINT,
      method: "GET",
    });

  const { data, error, isLoading } = useSWR(
    CONFIG_ENDPOINT,
    fetcher,
    defaultSWROption,
  );

  return {
    config: data
      ? {
        ...defaultConfig,
        ...data.data,
      }
      : undefined,
    error,
    isLoading,
  };
}

export default useConfig;
